import { render, staticRenderFns } from "./AttendedTransfer.vue?vue&type=template&id=a9013ec8&scoped=true&"
import script from "./AttendedTransfer.vue?vue&type=script&lang=js&"
export * from "./AttendedTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9013ec8",
  null
  
)

export default component.exports